<template>
  <div class="vcode-timer-btn" :class="[canHandle ? 'allow' : 'disabled']" @click="onClick">
    <div class="btn-txt" v-if="!isReqSending">{{ btnText }}</div>
    <div class="btn-loading" v-else>
      <img class="loading-icon" src="@/assets/loading_small.webp" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vcode-timer-btn',

    props: {
      // 倒计时时长
      seconds: {
        type: Number,
        default: 60
      },
      // 是否允许点击
      allowClick: {
        type: Boolean,
        default: false
      },
      // 点击发送事件（需要返回bool）
      onSend: {
        type: Function,
        default: undefined
      },
      onBeforeSend: {
        type: Function,
        default: undefined
      },
      // 发送前是否需要处理
      needBefore: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        curTick: 60, // 当前秒数
        timer: undefined, // 计时器

        // Ready, 发送验证码【首次等待】
        // Prepare, // 点击跟返回结果前的准备状态
        // Timing, // 计时中
        // Again, // 重新发送验证码【再次等待】
        state: 'Ready' // 当前状态
      }
    },

    computed: {
      // 是否正在发送请求
      isReqSending() {
        return this.state === 'Prepare'
      },

      // 按钮是否可点击操作
      canHandle() {
        if (!this.allowClick) return false
        if (['Ready', 'Again'].includes(this.state)) {
          return true
        } else {
          return false
        }
      },

      btnText() {
        switch (this.state) {
        default:
        case 'Ready':
          return this.$t('login.sendVcode') // 发送验证码
        case 'Prepare':
          return ''
        case 'Timing':
          return `${this.$t('login.countdown')}${this.curTick}s` // 倒计时
        case 'Again':
          return this.$t('login.reSendVcode') // 重新发送验证码
        }
      }
    },

    created() {
      this.state = 'Ready'
      this.curTick = this.seconds
    },

    methods: {
      onClick() {
        if (!this.canHandle) return

        if (this.needBefore) {
          if (this.onBeforeSend) {
            this.onBeforeSend()
          }
        } else {
          this.doHandle()
        }
      },

      async doHandle() {
        try {
          if (!this.canHandle) return
          this.state = 'Prepare'
          const isSuccess = await this.onSend()
          this.startTimer(isSuccess)
        } catch (error) {
          this.state = 'Again'
        }
      },

      // 开始计时
      startTimer(isSuccess) {
        const _this = this
        if (isSuccess) {
          _this.timer = setInterval(() => {
            _this.state = 'Timing'
            _this.curTick--
            if (_this.curTick <= 0) {
              _this.cancelTimer()
              _this.state = 'Again'
            }
          }, 1000)
        } else {
          _this.state = 'Again'
        }
      },

      // 完成计时
      cancelTimer() {
        this.curTick = this.seconds
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .vcode-timer-btn {
    white-space: nowrap;
    cursor: pointer;

    .btn-txt {
      font-size: 14px;
      font-weight: 400;
    }

    .btn-loading {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading-icon {
        width: 16px;
        height: 16px;
      }
    }

    &.allow {
      color: #1890ff;
    }

    &.disabled {
      color: #a4d4ff;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
</style>
